/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopGuildLeaderLeaderboard
 */
export interface TopGuildLeaderLeaderboard {
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderLeaderboard
     */
    guildIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderLeaderboard
     */
    guildName?: string;
    /**
     * 
     * @type {number}
     * @memberof TopGuildLeaderLeaderboard
     */
    totalPoints: number;
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderLeaderboard
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderLeaderboard
     */
    profilePicture?: string;
    /**
     * 
     * @type {number}
     * @memberof TopGuildLeaderLeaderboard
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof TopGuildLeaderLeaderboard
     */
    id: string;
}

/**
 * Check if a given object implements the TopGuildLeaderLeaderboard interface.
 */
export function instanceOfTopGuildLeaderLeaderboard(value: object): value is TopGuildLeaderLeaderboard {
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TopGuildLeaderLeaderboardFromJSON(json: any): TopGuildLeaderLeaderboard {
    return TopGuildLeaderLeaderboardFromJSONTyped(json, false);
}

export function TopGuildLeaderLeaderboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopGuildLeaderLeaderboard {
    if (json == null) {
        return json;
    }
    return {
        
        'guildIcon': json['guildIcon'] == null ? undefined : json['guildIcon'],
        'guildName': json['guildName'] == null ? undefined : json['guildName'],
        'totalPoints': json['totalPoints'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'profilePicture': json['profilePicture'] == null ? undefined : json['profilePicture'],
        'rank': json['rank'],
        'id': json['id'],
    };
}

export function TopGuildLeaderLeaderboardToJSON(json: any): TopGuildLeaderLeaderboard {
    return TopGuildLeaderLeaderboardToJSONTyped(json, false);
}

export function TopGuildLeaderLeaderboardToJSONTyped(value?: TopGuildLeaderLeaderboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guildIcon': value['guildIcon'],
        'guildName': value['guildName'],
        'totalPoints': value['totalPoints'],
        'nickname': value['nickname'],
        'profilePicture': value['profilePicture'],
        'rank': value['rank'],
        'id': value['id'],
    };
}

